import request from '@/utils/request'

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/api/dict/data/queryType/' + dictType,
    method: 'get'
  })
}

// 题库列表
// export function bankList(data = {}) {
//   return request({
//     url: '/api/bank/enabled',
//     method: 'post',
//     data
//   })
// }
export function bankList(data = {}) {
  return request({
    url: '/api/bank/practiceEnabled',
    method: 'post',
    data
  })
}
// 获取配置
export function getSysConfig(fields) {
  const formData = new FormData();
  formData.append("str", fields);
  return request({
    url: '/index/getIndexConfig',
    method: 'post',
    data: formData
  })
}